/*
 * ZOVERE — editorial product page (template product.zovere)
 *
 * Hero gallery: keeps the "01 — 07" index in step with Dawn's gallery and
 * fades in each newly selected photo. Dawn still owns every gallery
 * behaviour (thumbnails, swipe, lightbox, variant images); this only listens.
 */
(function () {
  'use strict';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.zpInit) return;
    var list = gallery.querySelector('.product__media-list');
    if (!list) return;
    gallery.dataset.zpInit = '1';

    var current = gallery.querySelector('[data-zp-index-current]');
    var desktop = window.matchMedia('(min-width: 750px)');
    var activeItem = list.querySelector('.product__media-item.is-active');

    function items() {
      return Array.prototype.filter.call(list.children, function (el) {
        return el.classList.contains('product__media-item');
      });
    }

    function setIndex(i) {
      if (current) current.textContent = pad(i + 1);
    }

    // Desktop: Dawn toggles .is-active on thumbnail click
    new MutationObserver(function () {
      var next = list.querySelector('.product__media-item.is-active');
      if (!next || next === activeItem) return;
      activeItem = next;
      if (desktop.matches) {
        setIndex(Math.max(0, items().indexOf(next)));
        next.classList.remove('zp-enter');
        // Restart the fade on the photo that just became visible
        void next.offsetWidth;
        next.classList.add('zp-enter');
      }
    }).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });

    list.addEventListener('animationend', function (event) {
      if (event.target.classList && event.target.classList.contains('zp-enter')) {
        event.target.classList.remove('zp-enter');
      }
    });

    // Phones: the photos are a swipe strip
    var ticking = false;
    list.addEventListener('scroll', function () {
      if (desktop.matches || ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (!list.clientWidth) return;
        var count = items().length;
        setIndex(Math.min(count - 1, Math.round(list.scrollLeft / list.clientWidth)));
      });
    }, { passive: true });

    desktop.addEventListener('change', function () {
      if (desktop.matches) {
        var active = list.querySelector('.product__media-item.is-active');
        setIndex(Math.max(0, items().indexOf(active)));
      } else {
        setIndex(list.clientWidth ? Math.round(list.scrollLeft / list.clientWidth) : 0);
      }
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
